import { render, staticRenderFns } from "./CotPropostaAccessoListaAttesaPage.vue?vue&type=template&id=5ff90dd6"
import script from "./CotPropostaAccessoListaAttesaPage.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoListaAttesaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports